import React, { useEffect } from "react";

//* ReactFlow Library
import ReactFlow, { Controls } from "reactflow";

import {
  nodeTypes,
  edgesTypes,
  generateNodesData,
  generateEdgesData,
  getAllTeamsKeyVal,
  defaultEdgeOptions,
  defaultViewport,
  proOptions,
} from "./utilities/helper";

const BracketMini = (props) => {
  const brackets = props.bracket[0] || [];

  const hideSeed = props.hide_bracket_seed;

  const titlesNode = props.titles || [];
  const bracketsData = brackets.map((bracket) => bracket[0]);
  const teamDataObj = Object.values(props.team_type);
  const allTeams = getAllTeamsKeyVal(props.all_teams);

  const nodes = generateNodesData(
    [...bracketsData, ...titlesNode],
    teamDataObj,
    allTeams,
    true,
    false,
    true,
    hideSeed
  );

  const edges = generateEdgesData(props.edges || []);

  return (
    <ReactFlow
      proOptions={proOptions}
      nodes={nodes}
      edges={edges}
      nodeTypes={nodeTypes}
      edgeTypes={edgesTypes}
      defaultViewport={defaultViewport}
      defaultEdgeOptions={defaultEdgeOptions}
      edgesFocusable={false}
      nodesFocusable={false}
      nodesDraggable={false}
      nodesConnectable={false}
      fitView
      minZoom={-Infinity}
    >
      <Controls showInteractive={false} />
    </ReactFlow>
  );
};

export default BracketMini;
